<template>
  <el-dialog
    top="15vh"
    title="User Guide"
    :modal="false"
    :visible.sync="dialogVisible"
    width="65%">

    <div style="padding-left:10px;">
        <UserGuideCarousel/>
    </div>

    <span slot="footer" class="dialog-footer">
        <!-- <el-button>下一条</el-button> -->
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button @click="goNext">下一条</el-button>
        <el-button @click="hide_remember">不再提示</el-button>
    </span>
    </el-dialog>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil'

export default {
    name : 'UserGuide',

    data() {
        return {
            dialogVisible : false
        };
    },

    mounted() {
        var _val = localStorage.getItem(CacheUtil.UserGuideShow) || "true";
        this.dialogVisible = 'true' == _val;
    },

    methods : {
        goNext() {
            this.$refs.carousel_1.next();
        },

        hide_remember() {
            if ( !confirm('确定不再提示？') ) {
                return;
            }

            localStorage.setItem(CacheUtil.UserGuideShow, 'false');
            this.dialogVisible = false;
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/UserGuide.vue